import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {GetBenefitDetailResponse} from "../responses/GetBenefitDetailResponse";
import {EndpointService} from "./endpoint.service";
import {GetOrderDetailsResponse} from "../responses/GetOrderDetailsResponse";
import {GetSubcriptionPaymentsResponse} from "../responses/GetSubscriptionPaymentsResponse";

@Injectable({providedIn: 'root'})
export class OrderDetailsService {
  constructor(private http: HttpClient) {
  }

  getOrderDetails(orderId: number, userId: string) {
    return this.http.get<GetOrderDetailsResponse>(EndpointService.getOrderDetails(userId, orderId), {});
  }

  getSubscriptionDetails(subscriptionId: number, userId: string) {
    return this.http.get<GetOrderDetailsResponse>(EndpointService.getSubscriptionDetails(userId, subscriptionId), {});
  }

  getSubscriptionPayments(subscriptionId: number) {
    return this.http.get<GetSubcriptionPaymentsResponse>(EndpointService.getSubscriptionPayments(subscriptionId), {});
  }

  getAutoOrderDetails(autoOrderId: number, userId: string) {
    return this.http.get<GetOrderDetailsResponse>(EndpointService.getAutoOrderDetails(userId, autoOrderId), {});
  }
}
